import Causal from '@/types/purchaseRequest/causal'
import { BaseService } from './../../base'
export class CausalService extends BaseService<Causal>() {
    static get entity (): string {
        return 'causal'
    }
    static get responseName (): string {
        return 'causal'
    }
}